
import Vue from "vue"
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";
import SVGIcon from "@/components/svgIcon/index.vue"
import { E2TopEvent, EMyBlogMainScrollEvent } from "@/eventBus";
export default Vue.extend({
	computed: {
		icon: () => faAngleUp
	},
	components: {
		SVGIcon
	},

	mounted() {
		this.$eventBus.on(E2TopEvent.show2Top, () => {
			this.show = true
		})
		this.$eventBus.on(E2TopEvent.hide2Top, () => {
			this.show = false
		})
	},
	methods: {
		toTop() {
			this.$eventBus.emit(EMyBlogMainScrollEvent.mainScroll2Top)
		}
	},
	data() {
		return {
			show: false
		}
	}

})
